// 根据环境引入不同配置
const environment = 'production'
const config = require('./env.' + environment)
module.exports = config